import React,{ useState} from 'react'
import {  Route, Routes,useNavigate } from "react-router-dom";
import Admin from './layout/Admin';
import Login from './pages/Login';
import { userSessionContext } from './components/user-context';
import AppGuidance from './pages/AppGuidance';
// import { Version } from './commons/inFormTypes'


function App() {
  const GUEST_USER = { Islogin: false, displayName: 'نام کاربر' }
  const [user, setUser] = useState(GUEST_USER)
  const [ score, setScore] = useState("0")
  const userToken = localStorage.getItem("user_token");
    const navigate = useNavigate();

    // useEffect(() => {
    //   const last_version = localStorage.getItem("version")        
    //   if(last_version !== Version){  
    //       localStorage.setItem("version", Version)
        
    //   }
    // }
    // ,[])

  // const [loading, setLoading] = useState(false)
  // const spinner = document.getElementById("spinner")

  // if(spinner) {
  //   setTimeout(() => {
  //     spinner.style.display= "none"
  //     setLoading(true)
  //   }, 3000);
  // }
  


  const logIn = (name) => {
    setUser({ Islogin: true, displayName: name })
  }

  const logOut = () => {
    localStorage.removeItem("user_token");
    localStorage.clear();
    setUser(GUEST_USER)
    navigate("/")
  }




  return (
    // loading && (  
    <userSessionContext.Provider  value={{score,user, logIn, logOut}}>
       <div>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/admin/*" element={<Admin />} />
          <Route path="appguidance" element={<AppGuidance/>} />
        </Routes>
      </div>
      </userSessionContext.Provider>
      // )
    
  )
}

export default App;
